import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Mock data for local development
const mockActivities = [
  {
    id: '1',
    name: 'Farm Tour & Organic Farming Workshop',
    description: 'Learn about sustainable farming practices and explore our 10-bigha farm',
    price: 500,
    duration: 3,
    maxParticipants: 15,
    category: 'Educational',
    images: ['/api/placeholder/400/300'],
    available: true,
    features: ['Guided tour', 'Hands-on experience', 'Organic lunch', 'Take-home produce']
  },
  {
    id: '2',
    name: 'Mango Harvesting Experience',
    description: 'Join us during mango season to pick fresh mangoes directly from trees',
    price: 300,
    duration: 2,
    maxParticipants: 10,
    category: 'Seasonal',
    images: ['/api/placeholder/400/300'],
    available: true,
    features: ['Tree climbing basics', 'Mango picking', 'Tasting session', 'Fresh mango basket']
  }
];

const mockAccommodations = [
  {
    id: '1',
    name: 'Eco Cottage',
    description: 'Traditional Bengali cottage with modern amenities surrounded by nature',
    pricePerNight: 2500,
    capacity: 4,
    images: ['/api/placeholder/400/300'],
    amenities: ['AC', 'Organic breakfast', 'Farm activities', 'Wifi'],
    available: true
  },
  {
    id: '2',
    name: 'Farm Tent Stay',
    description: 'Comfortable camping experience under the stars',
    pricePerNight: 1500,
    capacity: 2,
    images: ['/api/placeholder/400/300'],
    amenities: ['Bedding', 'Shared bathroom', 'Bonfire', 'Organic meals'],
    available: true
  }
];

export const fetchBookableItems = createAsyncThunk(
  'bookings/fetchBookableItems',
  async (_, { rejectWithValue }) => {
    try {
      // Mock API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      return {
        activities: mockActivities,
        accommodations: mockAccommodations
      };
    } catch (error) {
      return rejectWithValue('Failed to fetch booking items');
    }
  }
);

export const createBooking = createAsyncThunk(
  'bookings/createBooking',
  async (bookingData, { rejectWithValue }) => {
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      return {
        id: Date.now().toString(),
        ...bookingData,
        status: 'confirmed',
        bookingDate: new Date().toISOString(),
        confirmationNumber: 'VF' + Date.now()
      };
    } catch (error) {
      return rejectWithValue('Failed to create booking');
    }
  }
);

const initialState = {
  activities: [],
  accommodations: [],
  userBookings: [],
  loading: false,
  error: null,
  bookingSuccess: false
};

const bookingsSlice = createSlice({
  name: 'bookings',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearBookingSuccess: (state) => {
      state.bookingSuccess = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookableItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookableItems.fulfilled, (state, action) => {
        state.loading = false;
        state.activities = action.payload.activities;
        state.accommodations = action.payload.accommodations;
        state.error = null;
      })
      .addCase(fetchBookableItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.bookingSuccess = false;
      })
      .addCase(createBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.userBookings.push(action.payload);
        state.bookingSuccess = true;
        state.error = null;
      })
      .addCase(createBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.bookingSuccess = false;
      });
  },
});

export const { clearError, clearBookingSuccess } = bookingsSlice.actions;
export default bookingsSlice.reducer;